// eslint-disable-next-line import/prefer-default-export
export const STATIC_ACCESS_POINT_URL = 'https://legacy.tizeti.com/geniatechapi/index.php';
export const ACCESS_PERFORMANCE_URL = 'https://legacy.tizeti.com/cnmaestro/Views/index.php';
